import { SceneSetResponse } from '@bighealth/types';
import { APIRequestBody, APIResponse } from '../../types';
import { api } from '../../api';
import { AxiosRequestConfig } from 'axios';

export const get_interpolated_scene_set_with_id = async (
  args: get_interpolated_scene_set_with_id.Args,
  requestConfig?: AxiosRequestConfig
): Promise<get_interpolated_scene_set_with_id.Response> => {
  const request: get_interpolated_scene_set_with_id.Request = {
    service_name: 'SceneSet',
    service_version: '1',
    service_method: 'get_interpolated_scene_set_with_id',
    args,
  };

  return await api(request, requestConfig);
};

get_interpolated_scene_set_with_id.queryKey =
  'SceneSet/get_interpolated_scene_set_with_id';

export declare namespace get_interpolated_scene_set_with_id {
  export type Args = { id: number };

  export interface Request extends APIRequestBody {
    service_name: 'SceneSet';
    service_version: '1';
    service_method: 'get_interpolated_scene_set_with_id';
    args: Args;
  }

  export type Result = SceneSetResponse;

  export type Response = APIResponse<Result>;
}
